<div data-testid="coupon-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "coupon.management.title" | translate }}
  </h2>

  <app-search-form
    data-testid="coupon-search-form"
    [searchFormat]="searchConfig()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'coupon-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-button
        [testId]="'coupon-add-btn'"
        type="info"
        [outlined]="false"
        icon="add"
        [label]="'coupon.actions.new' | translate"
        (emitOnClick)="onAddCouponIssue()"
      ></app-button>
    </div>
  </app-search-form>

  <div class="flex-table-section">
    <advanced-data-table
      data-testid="coupon-table"
      #advancedTable
      [dataSource]="coupons()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="pageSize()"
      [first]="currentPage() * pageSize()"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      [showInternalColumnConfigButton]="false"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
    <ng-template #actionsTemplate let-rowData>
      <div class="actions-container flex gap-2 justify-center flex-wrap">
        <span
          [attr.data-testid]="
            'coupon-action-view-issued-coupons-' + rowData.id
          "
          (click)="onViewIssuedCoupons(rowData)"
          class="action-link action-view cursor-pointer"
        >
          {{ "coupon.actions.view_issued_coupons" | translate }}
        </span>
        <span
          [attr.data-testid]="'coupon-action-edit-' + rowData.id"
          (click)="onEdit(rowData)"
          class="action-link action-edit cursor-pointer"
        >
          {{ "common.actions.edit" | translate }}
        </span>
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>
